import differenceInSecondsFn from 'date-fns/differenceInSeconds'

function differenceInSeconds(dateLeft, dateRight) {
  return differenceInSecondsFn(dateLeft, dateRight)
}

export { differenceInSeconds }
